import React from 'react';
import { Box } from '@chakra-ui/react';

const AuthFormContainer = ({ children, ...props }) => {
    return (
        <Box
            w='100%'
            p={{ base: '0px', sm: '40px 55px', md: '50px 90px' }}
            borderRadius={{ base: '', sm: '4px' }}
            border={{
                base: '',
                sm: '1px solid #E8E8E8',
            }}
            {...props}
        >
            {children}
        </Box>
    );
};

export default AuthFormContainer;
